(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this._headerObserver = new ResizeObserver(entries => {
        document.documentElement.style.setProperty('--header-height', `${entries[0].contentRect.height}px`);
      });
      this._headerObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this._headerObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Transparent header: toggle solid bg after 50px scroll — inner pages only
  if (document.body.classList.contains('pj-inner-page')) {
    window.addEventListener('scroll', () => {
      document.body.classList.toggle('pj-header-scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pj-contact-split"] && !Shopify.designMode) return;
  try {
    
(function () {
  const FORM_ID = 'pj-contact-split-form-{{ section.id }}';

  const RULES = {
    required: {
      test: (v) => v.trim().length > 0,
      msg: 'This field is required.',
    },
    email: {
      test: (v) => {
        if (!v.trim()) return false;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
      },
      msg: (v) => (!v.trim() ? 'This field is required.' : 'Please enter a valid email address.'),
    },
    phone: {
      test: (v) => {
        if (!v.trim()) return true;
        return /^[+\d][\d\s\-().]{6,19}$/.test(v.trim());
      },
      msg: 'Please enter a valid phone number.',
    },
  };

  function getInput(field) {
    return field.querySelector('input, textarea');
  }

  function getErrorEl(field) {
    return field.querySelector('.pj-contact-split__error-msg');
  }

  function setError(field, msg) {
    field.classList.add('pj-contact-split__field--error');
    const err = getErrorEl(field);
    if (err) err.textContent = msg;
    const input = getInput(field);
    if (input) input.setAttribute('aria-invalid', 'true');
  }

  function clearError(field) {
    field.classList.remove('pj-contact-split__field--error');
    const err = getErrorEl(field);
    if (err) err.textContent = '';
    const input = getInput(field);
    if (input) input.removeAttribute('aria-invalid');
  }

  function validateField(field) {
    const ruleKey = field.dataset.validate;
    if (!ruleKey) return true;
    const rule = RULES[ruleKey];
    if (!rule) return true;
    const input = getInput(field);
    if (!input) return true;
    const valid = rule.test(input.value);
    if (!valid) {
      const msg = typeof rule.msg === 'function' ? rule.msg(input.value) : rule.msg;
      setError(field, msg);
      return false;
    }
    clearError(field);
    return true;
  }

  function init() {
    const form = document.getElementById(FORM_ID);
    if (!form) return;

    const validatedFields = form.querySelectorAll('[data-validate]');

    validatedFields.forEach((field) => {
      const input = getInput(field);
      if (!input) return;
      input.addEventListener('input', () => clearError(field));
    });

    form.addEventListener('submit', (e) => {
      let firstInvalid = null;
      validatedFields.forEach((field) => {
        const valid = validateField(field);
        if (!valid && !firstInvalid) firstInvalid = field;
      });

      if (firstInvalid) {
        e.preventDefault();
        const input = getInput(firstInvalid);
        if (input) input.focus();
        return;
      }

      const btn = form.querySelector('.pj-contact-split__submit');
      const textEl = form.querySelector('.pj-contact-split__submit-text');
      const loadEl = form.querySelector('.pj-contact-split__submit-loading');
      if (btn && textEl && loadEl) {
        btn.disabled = true;
        textEl.hidden = true;
        loadEl.hidden = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pj-wholesale-inquiry"] && !Shopify.designMode) return;
  try {
    
(function () {
  const FORM_ID = 'pj-wholesale-contact-form';

  const RULES = {
    required: {
      test: (v) => v.trim().length > 0,
      msg: 'This field is required.',
    },
    email: {
      test: (v) => {
        if (!v.trim()) return false;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
      },
      msg: (v) => (!v.trim() ? 'This field is required.' : 'Please enter a valid email address.'),
    },
    phone: {
      test: (v) => {
        if (!v.trim()) return true; // optional
        return /^[+\d][\d\s\-().]{6,19}$/.test(v.trim());
      },
      msg: 'Please enter a valid phone number.',
    },
    'phone-required': {
      test: (v) => {
        if (!v.trim()) return false;
        return /^[+\d][\d\s\-().]{6,19}$/.test(v.trim());
      },
      msg: (v) => (!v.trim() ? 'This field is required.' : 'Please enter a valid phone number.'),
    },
  };

  function getErrorEl(field) {
    return field.querySelector('.pj-wholesale-inquiry__error-msg');
  }

  function getInput(field) {
    return field.querySelector('input, select, textarea');
  }

  function setError(field, msg) {
    field.classList.add('pj-wholesale-inquiry__field--error');
    const err = getErrorEl(field);
    if (err) err.textContent = msg;
    const input = getInput(field);
    if (input) input.setAttribute('aria-invalid', 'true');
  }

  function clearError(field) {
    field.classList.remove('pj-wholesale-inquiry__field--error');
    const err = getErrorEl(field);
    if (err) err.textContent = '';
    const input = getInput(field);
    if (input) input.removeAttribute('aria-invalid');
  }

  function validateField(field) {
    const ruleKey = field.dataset.validate;
    if (!ruleKey) return true;
    const rule = RULES[ruleKey];
    if (!rule) return true;
    const input = getInput(field);
    if (!input) return true;
    const value = input.value;
    const valid = rule.test(value);
    if (!valid) {
      const msg = typeof rule.msg === 'function' ? rule.msg(value) : rule.msg;
      setError(field, msg);
      return false;
    }
    clearError(field);
    return true;
  }

  function init() {
    const form = document.getElementById(FORM_ID);
    if (!form) return;

    const validatedFields = form.querySelectorAll('[data-validate]');

    // Clear on input/change
    validatedFields.forEach((field) => {
      const input = getInput(field);
      if (!input) return;
      const evt = input.tagName === 'SELECT' ? 'change' : 'input';
      input.addEventListener(evt, () => clearError(field));
    });

    // Submit handler
    form.addEventListener('submit', (e) => {
      let firstInvalid = null;

      validatedFields.forEach((field) => {
        const valid = validateField(field);
        if (!valid && !firstInvalid) firstInvalid = field;
      });

      if (firstInvalid) {
        e.preventDefault();
        const input = getInput(firstInvalid);
        if (input) input.focus();
        return;
      }

      // Show loading state
      const btn = form.querySelector('.pj-wholesale-inquiry__submit');
      const textEl = form.querySelector('.pj-wholesale-inquiry__submit-text');
      const loadEl = form.querySelector('.pj-wholesale-inquiry__submit-loading');
      if (btn && textEl && loadEl) {
        btn.disabled = true;
        textEl.hidden = true;
        loadEl.hidden = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
